import React, { useEffect, useState } from "react";
import "./styles.scss";
import { ImageComponent } from "..";
import { motion, AnimatePresence } from "framer-motion";

const Index = ({
  data,
  imageList,
  imageListRight,
  logo,
  banner,
  title,
  content,
  btnType,
}) => {
  let inputElement = null;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndexRight, setCurrentIndexRight] = useState(0);

  useEffect(() => {
    if (imageList?.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % imageList?.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [imageList]);

  useEffect(() => {
    if (imageListRight?.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndexRight(
          (prevIndex) => (prevIndex + 1) % imageListRight?.length
        );
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [imageListRight]);

  inputElement = (
    <>
      <div className={`advPreview-image-wrapper `}>
        <div className="aiw-web-header">
          <div style={{ marginLeft: "5px", display: "flex", gap: "3px" }}>
            {" "}
            <div className="aiw-line-icon"></div>
            <div className="aiw-line-icon"></div>
            <div className="aiw-line-icon"></div>
          </div>
        </div>

        {data.type === "header" && (
          <div className="wpw-banner">
            {/* <div className="bg-color"></div> */}
            {Array.isArray(imageList) && imageList?.length > 0 ? (
              <AnimatePresence mode="wait">
                <motion.div
                  key={currentIndex}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.6 }}
                  className="motion-card-wrapper mt-2"
                  style={{ padding: "0 16px 0 16px " }}
                >
                  <ImageComponent
                    // key={index}
                    data={{
                      size: "header-ad-lg ",
                      imgUrl: imageList?.[currentIndex]?.url,
                      nonRemove: true,
                    }}
                    // onClickRemove={() =>
                    //   onClickRemoveImage(image?.[0]?.file_name, "header", 0)
                    // }
                  />
                </motion.div>
              </AnimatePresence>
            ) : (
              <div className="wpw-banner">
                <div className="wpw-text-header-wrapper">
                  <div className="wpw-text">
                    Ad space{" "}
                    <span style={{ color: " #000000", fontSize: "8px" }}>
                      728x90
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {data.type === "slider" && (
          <div className="wpw-banner">
            {/* <div className="bg-color"></div> */}
            {Array.isArray(imageListRight) && imageListRight?.length > 0 ? (
              <AnimatePresence mode="wait">
                <motion.div
                  key={currentIndexRight}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.6 }}
                  className="motion-card-wrapper mt-4"
                  style={{ padding: "0 16px 0 16px " }}
                >
                  <ImageComponent
                    // key={index}
                    data={{
                      size: "right-adv",
                      imgUrl: imageListRight?.[currentIndexRight]?.url,
                      nonRemove: true,
                    }}
                    // onClickRemove={() =>
                    //   onClickRemoveImage(image?.[0]?.file_name, "header", 0)
                    // }
                  />
                </motion.div>
              </AnimatePresence>
            ) : (
              <div className="wpw-text-slider-wrapper">
                <div className="wpw-text">
                  Ad space
                  <div style={{ color: " #000000", fontSize: "8px" }}>
                    620x620
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {data.type === "banner" && (
          <>
            <div className="wpw-banner">
              <div className="wpw-banner-combo">
                {banner?.url && (
                  <img className={"wpw-bc-img-bg"} src={banner?.url} alt={""} />
                )}
                {!banner?.url && (
                  <div
                    className={`wpw-bc-header ${banner?.url ? "remove" : ""}`}
                  />
                )}
                <div className="wpw-bc-header-content">
                  {logo ? (
                    <ImageComponent
                      // key={index}
                      data={{
                        size: "sm",
                        imgUrl: logo?.url,
                        nonRemove: true,
                      }}
                      // onClickRemove={() =>
                      //   onClickRemoveImage(image?.[0]?.file_name, "header", 0)
                      // }
                    />
                  ) : (
                    <div className="wpw-bc-img" />
                  )}
                  <div className="wpw-bc-title">
                    {title !== "" ? title : "Title"}
                  </div>
                </div>

                <div className="wpw-bc-content">
                  <p>
                    {content !== ""
                      ? content
                      : "Lorem Ipsum is simply dummy text of the printing and typesetting industry"}
                  </p>
                  <div className="wpw-bc-btn">
                    {btnType !== "" ? btnType : "More"}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );

  return <>{inputElement}</>;
};

Index.propTypes = {};

Index.defaultProps = {};

export default Index;
